import { CountriesApi } from '../../api'
import { getCountries } from '../../selectors'
import { setCountries, setCountriesLoading } from '../../actions'

export const fetchCountries = () => {
  return async (dispatch, getState) => {
    dispatch(setCountriesLoading(true))
    const state = getState()
    const countries = getCountries(state)
    if (!countries || (countries && !countries.length)) {
      const api = new CountriesApi()
      const result = await api.getCountries()
      dispatch(setCountries(result))
    }
    dispatch(setCountriesLoading(false))
  }
}
